/**
 * Registration: fills the token field in Tutor's registration forms
 * (templates/registration/token-field.php).
 *
 * The token is fetched rather than printed because the page is served from a
 * page cache. Without it the registration is refused, so a failed fetch is
 * left to the server to report: it asks the visitor to reload.
 */

const fill = ( field ) =>
	fetch( field.dataset.r2oRegistrationToken, {
		credentials: 'omit',
		cache: 'no-store',
	} )
		.then( ( response ) => ( response.ok ? response.json() : null ) )
		.then( ( body ) => {
			if ( typeof body?.token === 'string' ) {
				field.value = body.token;
			}
		} )
		.catch( () => {} );

const fillAll = () =>
	document
		.querySelectorAll( '[data-r2o-registration-token]' )
		.forEach( fill );

fillAll();

// A page restored from the back/forward cache keeps the old token, which may
// have expired while the visitor was elsewhere.
window.addEventListener( 'pageshow', ( event ) => {
	if ( event.persisted ) {
		fillAll();
	}
} );
